export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-900 text-center mb-8 md:mb-10">
          联系我们
        </h2>
        <div className="max-w-2xl mx-auto">
          <div className="bg-background-100 rounded-2xl p-6 md:p-10 text-center">
            <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 md:mb-5 rounded-2xl bg-primary-100 flex items-center justify-center">
              <i className="ri-mail-send-line text-2xl md:text-3xl text-primary-600"></i>
            </div>
            <h3 className="text-lg md:text-xl font-heading text-foreground-900 mb-3">
              投稿与咨询
            </h3>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5 md:mb-6">
              如需影视资源推荐、内容投稿或合作咨询，欢迎通过以下方式联系我们。牛牛影视团队将尽快为您提供帮助，共同打造更优质的免费观影体验。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
              <a
                href="mailto:contact@niuniu.example.com"
                className="w-full sm:w-auto px-6 py-2.5 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer transition-all duration-200"
              >
                发送邮件
              </a>
              <span className="text-sm text-foreground-500">
                或关注微信公众号"牛牛影视"
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}